











import {Component, Vue} from "vue-property-decorator";
import Navbar from "@/components/navbar/Navbar.vue";
import Jumbotron from "@/components/form/Jumbotron.vue";
import SiteFooter from "@/components/footer/SiteFooter.vue";
import Steps from "@/components/form/Steps.vue";
import FormTitle from "@/components/form/FormTitle.vue";
import FormOne from "@/components/form/FormOne.vue";

@Component({
  components: {FormOne, FormTitle, Steps, SiteFooter, Jumbotron, Navbar},
})
export default class Form1 extends Vue {}
